import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track9ABlue = ({ state, workState, onLabelClick }) => (
	<g id="Track9ABlue" transform="translate(1655.000000, 1210.000000)" className="track">
		<g id="line" transform="translate(0.000000, -0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<line x1="22.2084399" y1="27.0664063" x2="-9.40758582e-12" y2="0.0274107204" strokeWidth={tracksWidth}/>
			<polyline points="75 138 45.0565499 63.9212239 22.2084399 27.0664062" strokeWidth={tracksWidth}/>
		</g>

		<TrackArrow
			transform="translate(1.5, 2) rotate(-307.000000) translate(-9.323478, -8.870995)"
			points="13.3234776 16.870995 5.32347761 8.87099499 13.3234776 0.87099499"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track9ABlue')}
			coords="32.536678, 55.045787"
			text="9A"
			textCoordsX="10.3208008"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

Track9ABlue.propTypes = trackPropTypes;

export default Track9ABlue;
